module.exports = __webpack_public_path__ + "img/bg_03_green_right.3b8ef9cb.png";